// extracted by mini-css-extract-plugin
export default {"NoProjects":"NoProjects_NoProjects__2TJyo","Link":"NoProjects_Link__iYCLB"};